import React, { useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { PageContent, Link, Button } from 'nallian-shared-ui/lib/components';
import { Table, Actions, Params, Menu } from 'nallian-table-builder-ui';
import {
  INFINITE_SCROLL,
  COMMUNITY_MEMBERS_RESOURCE,
  ACTIONS,
  COMMUNITY_TAB_ACTIONS,
  COMMUNITY_DETAIL_TABS,
} from '../../constants';
import LinkCommunityMember from './NewCommunityMember';
import NewCommunityMember from '../../../../portal/community/members/components/NewCommunityMember';
import EditCommunityMember from './EditCommunityMember';
import ApplyOnboardingTemplate from './ApplyOnboardingTemplate';
import apiRoutes from '../../../../app/api/routes';
import CommunityMemberStateFilter from '../../../../portal/community/members/components/table/StateFilter';
import CommunityMemberRoles from './table/CommunityMemberRoles';
import CommunityMemberRolesFilter from './table/CommunityMemberRolesFilter';

const CommunityMembersOverview = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id, action, actionId } = useParams();

  const handleViewOrganisation = useCallback((event, value) => {
    const url = `/organisations/${value?.organisation?.id}/details`;
    if (event.ctrlKey) window.open(`${window.location.origin}${url}`);
    else navigate(url);
  }, [navigate]);

  return (
    <>
      <PageContent>
        <HasRight right="COMMUNITYMEMBERS.MANAGE.ALL">
          <LinkCommunityMember
            open={id && action === COMMUNITY_TAB_ACTIONS.LINK_MEMBER && !actionId}
          />
          <EditCommunityMember
            open={id && action === COMMUNITY_TAB_ACTIONS.EDIT_MEMBER && actionId}
          />
          <ApplyOnboardingTemplate
            open={id && action === COMMUNITY_TAB_ACTIONS.APPLY_ONBOARDING_TEMPLATE && actionId}
            communityId={id}
            returnRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.MEMBERS}`}
          />
          <NewCommunityMember
            returnUrl={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.MEMBERS}`}
            communityId={id}
            open={id && action === COMMUNITY_TAB_ACTIONS.NEW_MEMBER && !actionId}
          />
          <Link
            to={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.MEMBERS}/${COMMUNITY_TAB_ACTIONS.LINK_MEMBER}`}
          >
            <Button btnprimary icon="plus" content={t('linkExistingOrganisation')} />
          </Link>
          <Link
            to={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.MEMBERS}/${COMMUNITY_TAB_ACTIONS.NEW_MEMBER}`}
          >
            <Button btnprimary icon="plus" content={t('createNewMember')} />
          </Link>
        </HasRight>
        <Table
          url={apiRoutes.getCommunityMembers(id)}
          infiniteScroll={INFINITE_SCROLL}
          resource={COMMUNITY_MEMBERS_RESOURCE}
          idProp="organisation.id"
          pageSize={50}
          filtered
          noUserSettings
          resizable
        >
          <Actions.Link
            width="2.5rem"
            align="center"
            icon="eye"
            hasRight="COMMUNITYMEMBERS.MANAGE.ALL"
            url="/organisations/:organisation.id/details"
          />
          <Params.String
            label="organisationName"
            filterName="organisationName"
            name="organisation.name"
            width="15rem"
            minWidth="15rem"
            grow
          />
          <Params.Custom
            label="roles"
            name="organisationRoles"
            width="10rem"
            minWidth="10rem"
            communityId={id}
            filter={CommunityMemberRolesFilter}
            content={CommunityMemberRoles}
            grow
          />
          <Params.String
            label="stateName"
            name="state.name"
            width="5rem"
            minWidth="5rem"
            filter={CommunityMemberStateFilter}
            grow
          />
          <Params.DateTime name="createdOn" width="5rem" grow noFilter />
          <Menu width="3.5rem" align="center" hasRight="COMMUNITYMEMBERS.MANAGE.ALL">
            <Actions.Button
              onClick={handleViewOrganisation}
              label="viewOrganisation"
              icon="eye"
              url="/organisations/:organisation.id/details"
            />
            <Actions.Link
              label="applyOnboardingTemplate"
              icon="copy"
              url={`/communities/${ACTIONS.EDIT}/${id}/${COMMUNITY_DETAIL_TABS.MEMBERS}/${COMMUNITY_TAB_ACTIONS.APPLY_ONBOARDING_TEMPLATE}/:organisation.id`}
            />
            <Actions.Link
              label="edit"
              icon="edit"
              url={`/communities/${ACTIONS.EDIT}/${id}/${COMMUNITY_DETAIL_TABS.MEMBERS}/${COMMUNITY_TAB_ACTIONS.EDIT_MEMBER}/:organisation.id`}
            />
            <Actions.Delete url={apiRoutes.communityMember(id, ':organisation.id')} />
          </Menu>
        </Table>
      </PageContent>
    </>
  );
};

export default CommunityMembersOverview;
